import {BarChart} from "@mui/x-charts/BarChart";
import {useState} from "react";
import {currencyFormat} from "../../common/formatters/format";

const BarGrafica = ({ data, onDateClicked }) => {
    const label = useState(['']);
    const valor = useState([555])

    const onAxisClicked = (event, dataPoint) => {
        if (!dataPoint) return;
        const index = dataPoint.dataIndex;
        const originalItem = data?.datosGrafica?.[index];
        if (originalItem) onDateClicked(originalItem.fechaReal);
    };

    return(
            <BarChart
                leftAxis={null}
                xAxis={[{ scaleType: 'band', data: data?.datosGrafica ? data?.datosGrafica?.map(e => e.fecha) : label}]}
                series={[{
                        data: data?.datosGrafica ? data?.datosGrafica?.map(e => e.monto) : valor, color: '#1C70C2',
                        valueFormatter: currencyFormat
                    }]}
                sx={{height: '150px'}}
                onAxisClick={onAxisClicked}
            />
    )

}

export default BarGrafica;
